<template>
  <div id="app">
  <h1 class="inline" >Christopher Buck</h1>
  <span class="site-link">
  <a href="https://twitter.com/butterwell" rel="me">@butterwell&nbsp;on&nbsp;Twitter</a>
  <a href="https://github.com/butterwell" rel="me">Butterwell&nbsp;on&nbsp;Github</a>
  </span>
  <hr />
  <h2>A collection of popular color themes from
    <a href="https://color.adobe.com/explore/?filter=most-popular&time=month">
      color.adobe.com
    </a>
  </h2>
  <div id="container">
    <card
      v-for="cardband in cardbands"
      v-bind:cardband="cardband"
    ></card>
  </div>
  </div>
</template>

<script>
import cardbands from './cardbands.js'
import Card from './components/Card.vue'

export default {
  name: 'app',
  data: function() {
    return {
      cardbands: cardbands
    }
  },
  components: {
    Card
  }
}
</script>

<style>
@import url(//fonts.googleapis.com/css?family=Yanone+Kaffeesatz);
@import url(//fonts.googleapis.com/css?family=Droid+Serif:400,700,400italic);
@import url(//fonts.googleapis.com/css?family=Ubuntu+Mono:400,700,400italic);

body { font-family: 'Droid Serif'; }
h1, h2, h3 {
  display: inline-block;
  font-family: 'Yanone Kaffeesatz';
  font-weight: normal;
  line-height: 1em;
}
article {
  margin-left: 4em;
  max-width: 40em;
}
.site-link {
  font-family: 'Yanone Kaffeesatz';
  font-weight: normal;
  font-size: 1.3em;
  margin-left: 2em;
}
      .site-link a {
  margin-right: 0.2em;
}
.inline {
  display: inline-block;
}
.hide {
  display: none;
}
.square {
float:left;
position: relative;
width: 8.88888%;
font-size: 1.47vw;
padding-bottom : 8.88888%; /* = width for a 1:1 aspect ratio */
margin:1.11111%;
/*background-position:center center;
background-repeat:no-repeat;
background-size:cover; */ /* you change this to "contain" if you don't want the images to be cropped */
}

.card {
}

.article-details {
position: absolute;
width: 100%;
height: 100%;
}
.article-details div {
height: 20%
}

</style>
